import React from 'react';
import { ColumnToggleProps } from './column-toggle';
import ColumnCheckbox from './column-checkbox';

class ColumnToggleList extends React.Component<ColumnToggleProps> {
  onCheck = (dataKey: string) => () => {
    this.props.toggleColumn(dataKey);
  };

  render() {
    const { className, columns, visibleColumns } = this.props;

    return (
      <div className={className}>
        {columns.map(({ dataKey, label, starred }) => (
          <ColumnCheckbox
            key={dataKey}
            label={label}
            starred={starred}
            checked={visibleColumns[dataKey]}
            onCheck={this.onCheck(dataKey)}
          />
        ))}
      </div>
    );
  }
}

export default ColumnToggleList;
